module.exports = __webpack_public_path__ + "img/missionaries21_2019_7-7-2021.4e697727.jpg";